import { Command } from './SelfDrawingPath.types';

export function getCurrentCommandIndex(
  time: number,
  commands: Array<Command>
): number {
  let accumulatedTime = 0;

  let answer = commands.findIndex((command) => {
    accumulatedTime += command.duration;
    return accumulatedTime > time;
  });

  if (answer === -1) {
    return commands.length - 1;
  }

  return answer;
}

export function getCurrentCommandStartTime(
  time: number,
  commands: Array<Command>
): number {
  return commands
    .slice(0, getCurrentCommandIndex(time, commands))
    .reduce((acc, command) => acc + command.duration, 0);
}
